"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RBSAuthStatus = exports.RbsRegion = exports.parseClassValidatorErrors = exports.RESPONSE_TYPE = exports.createResponse = void 0;
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var loglevel_1 = __importDefault(require("loglevel"));
var firestore_1 = require("firebase/firestore");
var app_1 = require("firebase/app");
var auth_1 = require("firebase/auth");
var firestore_2 = require("firebase/firestore");
var rxjs_1 = require("rxjs");
var async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
var operators_1 = require("rxjs/operators");
var base64_1 = __importDefault(require("./base64"));
var axiosSetup_1 = __importDefault(require("./axiosSetup"));
var helpers_1 = require("./helpers");
Object.defineProperty(exports, "createResponse", { enumerable: true, get: function () { return helpers_1.createResponse; } });
Object.defineProperty(exports, "RESPONSE_TYPE", { enumerable: true, get: function () { return helpers_1.RESPONSE_TYPE; } });
Object.defineProperty(exports, "parseClassValidatorErrors", { enumerable: true, get: function () { return helpers_1.parseClassValidatorErrors; } });
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["DEBUG"] = 2] = "DEBUG";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
})(LogLevel || (LogLevel = {}));
var RbsRegion;
(function (RbsRegion) {
    RbsRegion[RbsRegion["euWest1"] = 0] = "euWest1";
    RbsRegion[RbsRegion["euWest1Beta"] = 1] = "euWest1Beta";
})(RbsRegion = exports.RbsRegion || (exports.RbsRegion = {}));
var RbsRegions = [
    {
        regionId: RbsRegion.euWest1,
        getUrl: 'https://core.rtbs.io',
        url: 'https://core-internal.rtbs.io',
        apiUrl: 'api.rtbs.io',
    },
    {
        regionId: RbsRegion.euWest1Beta,
        getUrl: 'https://core-test.rtbs.io',
        url: 'https://core-internal-beta.rtbs.io',
        apiUrl: 'test-api.rtbs.io',
    },
];
var RBSAuthStatus;
(function (RBSAuthStatus) {
    RBSAuthStatus["SIGNED_IN"] = "SIGNED_IN";
    RBSAuthStatus["SIGNED_IN_ANONYM"] = "SIGNED_IN_ANONYM";
    RBSAuthStatus["SIGNED_OUT"] = "SIGNED_OUT";
    RBSAuthStatus["AUTH_FAILED"] = "AUTH_FAILED";
})(RBSAuthStatus = exports.RBSAuthStatus || (exports.RBSAuthStatus = {}));
var RBS_TOKENS_KEY = 'RBS_TOKENS_KEY';
var RBS = /** @class */ (function () {
    function RBS() {
        var _this = this;
        this.firebaseApp = null;
        this.firestore = null;
        this.firebaseAuth = null;
        this.cloudObjects = [];
        this.commandQueue = new rxjs_1.Subject();
        this.customAuthQueue = new rxjs_1.Subject();
        this.clientConfig = null;
        this.axiosInstance = null;
        this.initialized = false;
        this.authStatusSubject = new rxjs_1.ReplaySubject(1);
        this.getServiceEndpoint = function (actionWrapper) {
            var endpoint = actionWrapper.tokenData.isServiceToken ? '/service/action' : '/user/action';
            var action = actionWrapper.action.action;
            var actionType = action.split('.')[2];
            endpoint = endpoint + "/" + _this.clientConfig.projectId + "/" + action;
            return endpoint;
        };
        this.getRegion = function () {
            var region = undefined;
            if (_this.clientConfig.regionConfiguration) {
                region = _this.clientConfig.regionConfiguration;
            }
            else {
                region = RbsRegions.find(function (r) { return r.regionId === _this.clientConfig.region; });
                if (!region) {
                    region = RbsRegions.find(function (r) { return r.regionId === RbsRegion.euWest1; });
                }
            }
            if (!region)
                throw new Error('Invalid rbs region');
            return region;
        };
        this.getBaseUrl = function (action) {
            var region = _this.getRegion();
            if (action.includes('.get.')) {
                return region.getUrl;
            }
            else {
                return region.url;
            }
        };
        this.getAuthChangedEvent = function (tokenData) {
            if (!tokenData) {
                return {
                    authStatus: RBSAuthStatus.SIGNED_OUT,
                };
            }
            else {
                var data = (0, jwt_decode_1.default)(tokenData.accessToken);
                if (data.anonymous) {
                    return {
                        authStatus: RBSAuthStatus.SIGNED_IN_ANONYM,
                        uid: data.userId,
                        identity: data.identity,
                    };
                }
                else {
                    return {
                        authStatus: RBSAuthStatus.SIGNED_IN,
                        uid: data.userId,
                        identity: data.identity,
                    };
                }
            }
        };
        this.fireAuthStatus = function (tokenData) {
            var event = _this.getAuthChangedEvent(tokenData);
            loglevel_1.default.info('RBSSDK LOG: fireAuthStatus event:', event);
            _this.authStatusSubject.next(event);
        };
        this._getStoredTokenData = function () { return __awaiter(_this, void 0, void 0, function () {
            var storedTokenData, item, item;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof document != 'undefined')) return [3 /*break*/, 1];
                        item = localStorage.getItem(this.getTokenDataKey());
                        if (item) {
                            storedTokenData = JSON.parse(item);
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(typeof navigator != 'undefined' && navigator.product == 'ReactNative')) return [3 /*break*/, 3];
                        return [4 /*yield*/, async_storage_1.default.getItem(this.getTokenDataKey())];
                    case 2:
                        item = _a.sent();
                        if (item) {
                            storedTokenData = JSON.parse(item);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        // I'm in node js
                        // Node environment
                        storedTokenData = this.latestTokenData;
                        _a.label = 4;
                    case 4: return [2 /*return*/, storedTokenData];
                }
            });
        }); };
        this.logMessage = function (logMessage) { };
        this.getActionWithTokenData = function (actionWrapper) {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var now, storedTokenData, accessTokenExpiresAt, refreshTokenExpiresAt, _a, err_1, url, params, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            loglevel_1.default.info('RBSSDK LOG: getActionWithTokenData started');
                            loglevel_1.default.info('RBSSDK LOG: secretKey and serviceId not found');
                            now = this.getSafeNow();
                            loglevel_1.default.info('RBSSDK LOG: now:', now);
                            return [4 /*yield*/, this._getStoredTokenData()];
                        case 1:
                            storedTokenData = _c.sent();
                            loglevel_1.default.info('RBSSDK LOG: storedTokenData:', storedTokenData);
                            if (!storedTokenData) return [3 /*break*/, 7];
                            loglevel_1.default.info('RBSSDK LOG: storedTokenData is defined');
                            accessTokenExpiresAt = (0, jwt_decode_1.default)(storedTokenData.accessToken).exp || 0;
                            refreshTokenExpiresAt = (0, jwt_decode_1.default)(storedTokenData.refreshToken).exp || 0;
                            // If token doesn't need refreshing return it.
                            if (refreshTokenExpiresAt > now && accessTokenExpiresAt > now) {
                                loglevel_1.default.info('RBSSDK LOG: returning same token');
                                // Just return same token
                                actionWrapper.tokenData = storedTokenData;
                            }
                            if (!(refreshTokenExpiresAt > now && accessTokenExpiresAt <= now)) return [3 /*break*/, 6];
                            // now + 280 -> only wait 20 seconds for debugging
                            // Refresh token
                            loglevel_1.default.info('RBSSDK LOG: token refresh needed');
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, 4, , 5]);
                            _a = actionWrapper;
                            return [4 /*yield*/, this.getP(this.getBaseUrl('') + '/public/auth-refresh', {
                                    refreshToken: storedTokenData.refreshToken,
                                })];
                        case 3:
                            _a.tokenData = _c.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            err_1 = _c.sent();
                            this.signOut();
                            return [3 /*break*/, 5];
                        case 5:
                            loglevel_1.default.info('RBSSDK LOG: refreshed tokenData:', actionWrapper.tokenData);
                            _c.label = 6;
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            loglevel_1.default.info('RBSSDK LOG: getting anonym token');
                            url = this.getBaseUrl('') + '/public/anonymous-auth';
                            params = {
                                projectId: this.clientConfig.projectId,
                                developerId: this.clientConfig.developerId,
                                serviceId: this.clientConfig.serviceId,
                            };
                            if (this.clientConfig.anonymTokenTTL) {
                                params.ttlInSeconds = this.clientConfig.anonymTokenTTL;
                            }
                            _b = actionWrapper;
                            return [4 /*yield*/, this.getP(url, params)];
                        case 8:
                            _b.tokenData = _c.sent();
                            loglevel_1.default.info('RBSSDK LOG: fetched anonym token:', actionWrapper.tokenData);
                            _c.label = 9;
                        case 9:
                            loglevel_1.default.info('RBSSDK LOG: resolving with actionWrapper:', actionWrapper);
                            resolve(actionWrapper);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        this.getP = function (url, queryParams) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axiosInstance.get(url, { params: queryParams })];
                    case 1: return [2 /*return*/, (_a.sent()).data];
                }
            });
        }); };
        this.getPlatform = function () {
            var _a;
            return ((_a = _this.clientConfig) === null || _a === void 0 ? void 0 : _a.platform) ? _this.clientConfig.platform : 'WEB';
        };
        this.request = function (url, actionWrapper) { return __awaiter(_this, void 0, void 0, function () {
            var data, params, key, _a, config, request, response, error_1;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        data = (_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.data;
                        params = {
                            _token: (_c = actionWrapper.tokenData) === null || _c === void 0 ? void 0 : _c.accessToken,
                        };
                        for (key in data.querystring || []) {
                            params[key] = data.querystring[key];
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        if (!this.axiosInstance)
                            throw new Error('Axios instance is null');
                        return [4 /*yield*/, this.axiosInstance({
                                url: url,
                                method: (_d = data.httpMethod) !== null && _d !== void 0 ? _d : 'post',
                                params: params,
                                data: data.payload,
                                headers: __assign(__assign({}, data.headers), { accept: 'text/plain', 'Content-Type': 'text/plain' }),
                            })];
                    case 2:
                        _a = _e.sent(), config = _a.config, request = _a.request, response = __rest(_a, ["config", "request"]);
                        actionWrapper.response = response;
                        return [2 /*return*/, actionWrapper];
                    case 3:
                        error_1 = _e.sent();
                        actionWrapper.responseError = error_1;
                        throw actionWrapper;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.post = function (url, actionWrapper) {
            return new Promise(function (resolve, reject) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                var params = {
                    auth: (_a = actionWrapper.tokenData) === null || _a === void 0 ? void 0 : _a.accessToken,
                };
                var data = (_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.data;
                if ((_c = actionWrapper.action) === null || _c === void 0 ? void 0 : _c.targetServiceId) {
                    params.targetServiceId = (_d = actionWrapper.action) === null || _d === void 0 ? void 0 : _d.targetServiceId;
                }
                if ((_e = actionWrapper.action) === null || _e === void 0 ? void 0 : _e.relatedUserId) {
                    params.relatedUserId = (_f = actionWrapper.action) === null || _f === void 0 ? void 0 : _f.relatedUserId;
                }
                if ((_g = actionWrapper.action) === null || _g === void 0 ? void 0 : _g.headers) {
                    params.headers = base64_1.default.urlEncode(JSON.stringify((_h = actionWrapper.action) === null || _h === void 0 ? void 0 : _h.headers));
                }
                if ((_j = actionWrapper.action) === null || _j === void 0 ? void 0 : _j.culture) {
                    params.culture = actionWrapper.action.culture;
                }
                if ((_k = actionWrapper.action) === null || _k === void 0 ? void 0 : _k.pop) {
                    params.pop = 'true';
                }
                params.platform = _this.getPlatform();
                _this.axiosInstance.post(url, data, {
                    params: params,
                })
                    .then(function (resp) {
                    actionWrapper.response = resp.data;
                    resolve(actionWrapper);
                })
                    .catch(function (err) {
                    actionWrapper.responseError = err;
                    reject(actionWrapper);
                });
            });
        };
        this.getParams = function (actionWrapper) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var params = {
                auth: (_a = actionWrapper.tokenData) === null || _a === void 0 ? void 0 : _a.accessToken,
            };
            if ((_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.data) {
                var data = ((_c = actionWrapper.action) === null || _c === void 0 ? void 0 : _c.data) ? (_d = actionWrapper.action) === null || _d === void 0 ? void 0 : _d.data : {};
                params.data = base64_1.default.urlEncode(JSON.stringify(data));
            }
            if ((_e = actionWrapper.action) === null || _e === void 0 ? void 0 : _e.targetServiceId) {
                params.targetServiceId = (_f = actionWrapper.action) === null || _f === void 0 ? void 0 : _f.targetServiceId;
            }
            if ((_g = actionWrapper.action) === null || _g === void 0 ? void 0 : _g.relatedUserId) {
                params.relatedUserId = (_h = actionWrapper.action) === null || _h === void 0 ? void 0 : _h.relatedUserId;
            }
            if ((_j = actionWrapper.action) === null || _j === void 0 ? void 0 : _j.headers) {
                params.headers = base64_1.default.urlEncode(JSON.stringify((_k = actionWrapper.action) === null || _k === void 0 ? void 0 : _k.headers));
            }
            if ((_l = actionWrapper.action) === null || _l === void 0 ? void 0 : _l.culture) {
                params.culture = actionWrapper.action.culture;
            }
            if ((_m = actionWrapper.action) === null || _m === void 0 ? void 0 : _m.pop) {
                params.pop = 'true';
            }
            params.platform = _this.getPlatform();
            return params;
        };
        this.get = function (url, actionWrapper) {
            return new Promise(function (resolve, reject) {
                var _a;
                var _b, _c;
                var params = _this.getParams(actionWrapper);
                if ((_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.generateGetUrl) {
                    // Don't get from server but just return get url
                    var url_1 = _this.getBaseUrl(actionWrapper.action.action) + _this.getServiceEndpoint(actionWrapper) + '?';
                    for (var _i = 0, _d = Object.keys(params); _i < _d.length; _i++) {
                        var k = _d[_i];
                        url_1 = "" + url_1 + k + "=" + params[k] + "&";
                    }
                    actionWrapper.url = url_1;
                    resolve(actionWrapper);
                }
                else {
                    _this.axiosInstance.get(url, {
                        params: params,
                        headers: __assign((_a = {}, _a['Content-Type'] = 'text/plain', _a), (_c = actionWrapper.action) === null || _c === void 0 ? void 0 : _c.headers),
                    })
                        .then(function (resp) {
                        actionWrapper.response = resp.data;
                        resolve(actionWrapper);
                    })
                        .catch(function (err) {
                        actionWrapper.responseError = err;
                        reject(actionWrapper);
                    });
                }
            });
        };
        this.getPlain = function (url, params, actionWrapper) {
            return new Promise(function (resolve, reject) {
                _this.axiosInstance.get(url, {
                    params: params,
                })
                    .then(function (resp) {
                    actionWrapper.response = resp;
                    resolve(actionWrapper);
                })
                    .catch(function (err) {
                    actionWrapper.responseError = err;
                    reject(actionWrapper);
                });
            });
        };
        this.getSafeNow = function () {
            return Math.round(new Date().getTime() / 1000) + 30; // Plus 30 seconds, just in case.
        };
        this.getTokenDataKey = function () {
            var _a;
            return RBS_TOKENS_KEY + "." + ((_a = _this.clientConfig) === null || _a === void 0 ? void 0 : _a.projectId);
        };
        this.setTokenData = function (tokenData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof document != 'undefined')) return [3 /*break*/, 1];
                        // I'm on the web!
                        // Browser environment
                        localStorage.setItem(this.getTokenDataKey(), JSON.stringify(tokenData));
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(typeof navigator != 'undefined' && navigator.product == 'ReactNative')) return [3 /*break*/, 3];
                        // I'm in react-native
                        return [4 /*yield*/, async_storage_1.default.setItem(this.getTokenDataKey(), JSON.stringify(tokenData))];
                    case 2:
                        // I'm in react-native
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        // I'm in node js
                        // Node environment
                        this.latestTokenData = tokenData;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        // PUBLIC METHODS
        this.getStoredTokenData = function () { return __awaiter(_this, void 0, void 0, function () {
            var storedTokenData, data, accessTokenExpiresAt, refreshTokenExpiresAt, storedTokenData, data, accessTokenExpiresAt, refreshTokenExpiresAt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof document != 'undefined')) return [3 /*break*/, 1];
                        storedTokenData = localStorage.getItem(this.getTokenDataKey());
                        if (storedTokenData) {
                            data = JSON.parse(storedTokenData);
                            accessTokenExpiresAt = (0, jwt_decode_1.default)(data.accessToken).exp || 0;
                            refreshTokenExpiresAt = (0, jwt_decode_1.default)(data.refreshToken).exp || 0;
                            data.accessTokenExpiresAt = accessTokenExpiresAt;
                            data.refreshTokenExpiresAt = refreshTokenExpiresAt;
                            return [2 /*return*/, data];
                        }
                        else {
                            return [2 /*return*/, undefined];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!(typeof navigator != 'undefined' && navigator.product == 'ReactNative')) return [3 /*break*/, 3];
                        return [4 /*yield*/, async_storage_1.default.getItem(this.getTokenDataKey())];
                    case 2:
                        storedTokenData = _a.sent();
                        if (storedTokenData) {
                            data = JSON.parse(storedTokenData);
                            accessTokenExpiresAt = (0, jwt_decode_1.default)(data.accessToken).exp || 0;
                            refreshTokenExpiresAt = (0, jwt_decode_1.default)(data.refreshToken).exp || 0;
                            data.accessTokenExpiresAt = accessTokenExpiresAt;
                            data.refreshTokenExpiresAt = refreshTokenExpiresAt;
                            return [2 /*return*/, data];
                        }
                        else {
                            return [2 /*return*/, undefined];
                        }
                        return [3 /*break*/, 4];
                    case 3: 
                    // Node environment
                    return [2 /*return*/, this.latestTokenData];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.getUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var tokenData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStoredTokenData()];
                    case 1:
                        tokenData = _a.sent();
                        if (!tokenData)
                            return [2 /*return*/, null];
                        return [2 /*return*/, (0, jwt_decode_1.default)(tokenData.accessToken)];
                }
            });
        }); };
        this.generatePublicGetActionUrl = function (action) {
            var actionWrapper = {
                action: action,
                tokenData: {
                    isServiceToken: false,
                    accessToken: '',
                    refreshToken: '',
                    accessTokenExpiresAt: 0,
                    refreshTokenExpiresAt: 0,
                },
            };
            var params = _this.getParams(actionWrapper);
            // Don't get from server but just return get url
            var url = _this.getBaseUrl(actionWrapper.action.action) + _this.getServiceEndpoint(actionWrapper) + '?';
            for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
                var k = _a[_i];
                url = "" + url + k + "=" + params[k] + "&";
            }
            return url;
        };
        this.generateGetActionUrl = function (action) {
            if (!_this.initialized)
                throw new Error('RBS SDK is not initialized');
            if (!action.culture)
                action.culture = 'en-US';
            return new Promise(function (resolve, reject) {
                if (!action.onSuccess && !action.onError) {
                    action.onSuccess = resolve;
                    action.onError = reject;
                }
                action.generateGetUrl = true;
                _this.commandQueue.next(action);
            });
        };
        this.send = function (action) {
            if (!_this.initialized)
                throw new Error('RBS SDK is not initialized');
            if (!action.culture)
                action.culture = 'en-US';
            return new Promise(function (resolve, reject) {
                if (!action.onSuccess && !action.onError) {
                    action.onSuccess = resolve;
                    action.onError = reject;
                }
                _this.commandQueue.next(action);
            });
        };
        this.authenticateWithCustomToken = function (token) {
            if (!_this.initialized)
                throw new Error('RBS SDK is not initialized');
            return new Promise(function (resolve, reject) {
                var action = {
                    action: 'customauth',
                    data: token,
                    onSuccess: resolve,
                    onError: reject,
                };
                _this.customAuthQueue.next(action);
            });
        };
        this.signOut = function () {
            if (!_this.initialized)
                throw new Error('RBS SDK is not initialized');
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var action, endpoint, tokenData, err_2, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            action = 'rbs.core.request.LOGOUT_USER';
                            endpoint = this.getBaseUrl(action) + "/user/action/" + this.clientConfig.projectId + "/" + action;
                            return [4 /*yield*/, this.getStoredTokenData()];
                        case 1:
                            tokenData = _b.sent();
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, this.post(endpoint, {
                                    tokenData: tokenData,
                                    action: {
                                        action: action,
                                        data: {
                                            refreshToken: tokenData === null || tokenData === void 0 ? void 0 : tokenData.refreshToken,
                                        },
                                    },
                                })];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            err_2 = _b.sent();
                            return [3 /*break*/, 5];
                        case 5:
                            if (!(typeof document != 'undefined')) return [3 /*break*/, 6];
                            // I'm on the web!
                            // Browser environment
                            localStorage.removeItem(this.getTokenDataKey());
                            return [3 /*break*/, 9];
                        case 6:
                            if (!(typeof navigator != 'undefined' && navigator.product == 'ReactNative')) return [3 /*break*/, 8];
                            // I'm in react-native
                            return [4 /*yield*/, async_storage_1.default.removeItem(this.getTokenDataKey())];
                        case 7:
                            // I'm in react-native
                            _b.sent();
                            return [3 /*break*/, 9];
                        case 8:
                            // I'm in node js
                            // Node environment
                            this.latestTokenData = undefined;
                            _b.label = 9;
                        case 9:
                            _a = this.fireAuthStatus;
                            return [4 /*yield*/, this.getStoredTokenData()];
                        case 10:
                            _a.apply(this, [_b.sent()]);
                            return [4 /*yield*/, this.cleanInitFirebase()];
                        case 11:
                            _b.sent();
                            resolve(true);
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        this.initFirebase = function () { return __awaiter(_this, void 0, void 0, function () {
            var firebaseConfig;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getStoredTokenData()];
                    case 1:
                        firebaseConfig = (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.firebase;
                        if (!firebaseConfig)
                            return [2 /*return*/];
                        if (!!this.firebaseApp) return [3 /*break*/, 3];
                        this.firebaseApp = (0, app_1.initializeApp)({
                            apiKey: firebaseConfig.apiKey,
                            authDomain: firebaseConfig.projectId + '.firebaseapp.com',
                            projectId: firebaseConfig.projectId,
                        });
                        this.firestore = (0, firestore_1.getFirestore)(this.firebaseApp);
                        this.firebaseAuth = (0, auth_1.getAuth)(this.firebaseApp);
                        return [4 /*yield*/, (0, auth_1.signInWithCustomToken)(this.firebaseAuth, firebaseConfig.customToken)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getFirebaseListeners = function (data, queue, key) { return __awaiter(_this, void 0, void 0, function () {
            var userData, documentId, collection, document, unsubscribe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getUser()];
                    case 1:
                        userData = _a.sent();
                        if (!userData && key !== 'public')
                            return [2 /*return*/, null];
                        documentId = data.instanceId;
                        collection = "/projects/" + this.clientConfig.projectId + "/classes/" + data.classId + "/instances";
                        if (key === 'role') {
                            documentId = userData.identity;
                            collection += "/" + data.instanceId + "/roleState";
                        }
                        if (key === 'user') {
                            documentId = userData.userId;
                            collection += "/" + data.instanceId + "/userState";
                        }
                        document = (0, firestore_2.doc)(this.firestore, collection, documentId);
                        unsubscribe = (0, firestore_2.onSnapshot)(document, function (doc) {
                            var data = Object.assign({}, doc.data());
                            for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
                                var key_1 = _a[_i];
                                if (key_1.startsWith('__'))
                                    delete data[key_1];
                            }
                            queue.next(data);
                        });
                        return [2 /*return*/, unsubscribe];
                }
            });
        }); };
        this.cleanInitFirebase = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // unsubscribe from all events
                        this.cloudObjects.map(function (cloudObject) {
                            cloudObject.unsubscribers.map(function (unsubscribe) { return unsubscribe && unsubscribe(); });
                        });
                        this.cloudObjects = [];
                        if (!this.firebaseAuth) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, auth_1.signOut)(this.firebaseAuth)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.firebaseApp = null;
                        this.firestore = null;
                        this.firebaseAuth = null;
                        return [2 /*return*/];
                }
            });
        }); };
        this.isCosAction = function (action) {
            return ['rbs.core.request.INSTANCE', 'rbs.core.request.CALL', 'rbs.core.request.STATE'].includes(action);
        };
        this.getCosEndpoint = function (method, classId, instanceId, methodId) {
            var region = _this.getRegion();
            return "https://" + _this.clientConfig.projectId + "." + region.apiUrl + "/" + method + "/" + classId + (methodId ? '/' + methodId : '') + (instanceId ? '/' + instanceId : '');
        };
        this.getCloudObject = function (data) { return __awaiter(_this, void 0, void 0, function () {
            var instanceResponse, seekedObject, queues, state, unsubscribers, _a, _b, _c, _d, _e, _f, call, getState;
            var _this = this;
            var _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, this.send({
                            action: 'rbs.core.request.INSTANCE',
                            data: data,
                            token: data.token,
                        })];
                    case 1:
                        instanceResponse = (_j.sent()).data;
                        if (!!this.firebaseApp) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.initFirebase()];
                    case 2:
                        _j.sent();
                        _j.label = 3;
                    case 3:
                        if (instanceResponse === null || instanceResponse === void 0 ? void 0 : instanceResponse.instanceId)
                            data.instanceId = instanceResponse.instanceId;
                        seekedObject = this.cloudObjects.find(function (cloudObject) { return cloudObject.config.classId === data.classId && cloudObject.config.instanceId === data.instanceId; });
                        if (seekedObject)
                            return [2 /*return*/, {
                                    instanceId: seekedObject.config.instanceId,
                                    call: seekedObject.call,
                                    state: seekedObject.state,
                                    getState: seekedObject.getState,
                                    methods: seekedObject.methods || [],
                                    isNewInstance: seekedObject.isNewInstance,
                                }];
                        queues = {
                            roleQueue: new rxjs_1.ReplaySubject(1),
                            userQueue: new rxjs_1.ReplaySubject(1),
                            publicQueue: new rxjs_1.ReplaySubject(1),
                        };
                        state = {
                            role: queues.roleQueue.asObservable(),
                            user: queues.userQueue.asObservable(),
                            public: queues.publicQueue.asObservable(),
                        };
                        unsubscribers = [];
                        _b = (_a = unsubscribers).push;
                        return [4 /*yield*/, this.getFirebaseListeners(data, queues.roleQueue, 'role')];
                    case 4:
                        _b.apply(_a, [_j.sent()]);
                        _d = (_c = unsubscribers).push;
                        return [4 /*yield*/, this.getFirebaseListeners(data, queues.userQueue, 'user')];
                    case 5:
                        _d.apply(_c, [_j.sent()]);
                        _f = (_e = unsubscribers).push;
                        return [4 /*yield*/, this.getFirebaseListeners(data, queues.publicQueue, 'public')];
                    case 6:
                        _f.apply(_e, [_j.sent()]);
                        call = function (params) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.send({
                                            action: 'rbs.core.request.CALL',
                                            data: __assign(__assign({}, params), { classId: data.classId, instanceId: data.instanceId }),
                                            token: params.token,
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        getState = function (params) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.send({
                                            action: 'rbs.core.request.STATE',
                                            data: __assign(__assign({}, params), { classId: data.classId, instanceId: data.instanceId }),
                                            token: params === null || params === void 0 ? void 0 : params.token,
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); };
                        this.cloudObjects.push({
                            config: data,
                            isNewInstance: (_g = instanceResponse === null || instanceResponse === void 0 ? void 0 : instanceResponse.newInstance) !== null && _g !== void 0 ? _g : false,
                            methods: instanceResponse === null || instanceResponse === void 0 ? void 0 : instanceResponse.methods,
                            call: call,
                            state: state,
                            getState: getState,
                            unsubscribers: unsubscribers,
                        });
                        return [2 /*return*/, { instanceId: data.instanceId, state: state, call: call, getState: getState, isNewInstance: (_h = instanceResponse === null || instanceResponse === void 0 ? void 0 : instanceResponse.newInstance) !== null && _h !== void 0 ? _h : false, methods: (instanceResponse === null || instanceResponse === void 0 ? void 0 : instanceResponse.methods) || [] }];
                }
            });
        }); };
    }
    RBS.prototype.isNode = function () {
        return typeof window === 'undefined';
    };
    Object.defineProperty(RBS.prototype, "authStatus", {
        get: function () {
            return this.authStatusSubject.asObservable().pipe((0, operators_1.distinctUntilChanged)(function (a, b) { return a.authStatus === b.authStatus && a.identity === b.identity && a.uid === b.uid; }));
            // .pipe(debounce(() => timer(100)))
        },
        enumerable: false,
        configurable: true
    });
    RBS.clearTokens = function () {
        if (typeof document != 'undefined') {
            // I'm on the web!
            // Browser environment
            for (var key in localStorage) {
                if (key.startsWith(RBS_TOKENS_KEY))
                    localStorage.removeItem(key);
            }
        }
    };
    RBS.getInstance = function (config) {
        if (config === void 0) { config = null; }
        if (!RBS.instances)
            RBS.instances = [];
        var instance = RBS.instances.find(function (i) { var _a; return ((_a = i.clientConfig) === null || _a === void 0 ? void 0 : _a.projectId) === (config === null || config === void 0 ? void 0 : config.projectId); });
        if (!instance) {
            instance = new RBS();
            if (config) {
                instance.init(config);
            }
            RBS.instances.push(instance);
        }
        return instance;
    };
    RBS.dispose = function () {
        RBS.instances = [];
    };
    RBS.prototype.init = function (config) {
        var _this = this;
        if (this.initialized)
            throw new Error('RBS SDK already initialized.');
        this.initialized = true;
        var axiosRequestConfiguration = {
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000,
        };
        this.axiosInstance = (0, axiosSetup_1.default)(axiosRequestConfiguration);
        config.logLevel ? loglevel_1.default.setLevel(config.logLevel) : loglevel_1.default.setLevel('ERROR');
        this.clientConfig = config;
        if (!this.clientConfig.region)
            this.clientConfig.region = RbsRegion.euWest1;
        var incomingAction = this.commandQueue.asObservable();
        var actionResult = incomingAction.pipe((0, operators_1.concatMap)(function (action) { return __awaiter(_this, void 0, void 0, function () {
            var actionWrapper;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionWrapper = {
                            action: action,
                        };
                        return [4 /*yield*/, this.getActionWithTokenData(actionWrapper)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); }), (0, operators_1.tap)(function (actionWrapper) {
            _this.fireAuthStatus(actionWrapper.tokenData);
        }), (0, operators_1.filter)(function (actionWrapper) { return actionWrapper.tokenData != null; }), (0, operators_1.tap)(function (actionWrapper) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.setTokenData(actionWrapper.tokenData)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }), (0, operators_1.mergeMap)(function (ev) {
            var _a;
            var endpoint = ev.tokenData.isServiceToken ? '/service/action' : '/user/action';
            var action = ev.action.action;
            var actionType = action.split('.')[2];
            endpoint = endpoint + "/" + _this.clientConfig.projectId + "/" + action;
            endpoint = _this.getBaseUrl(action) + _this.getServiceEndpoint(ev);
            if ((_a = ev.action) === null || _a === void 0 ? void 0 : _a.token) {
                ev.tokenData.accessToken = ev.action.token;
            }
            if (_this.isCosAction(action)) {
                var cosData = ev.action.data;
                endpoint = _this.getCosEndpoint(action.split('.')[3], cosData.classId, cosData.key ? cosData.key.name + "!" + cosData.key.value : cosData.instanceId, cosData.method);
                return (0, rxjs_1.defer)(function () { return _this.request(endpoint, ev); }).pipe((0, operators_1.materialize)());
            }
            if (actionType === 'get') {
                return (0, rxjs_1.defer)(function () { return _this.get(endpoint, ev); }).pipe((0, operators_1.materialize)());
            }
            else {
                return (0, rxjs_1.defer)(function () { return _this.post(endpoint, ev); }).pipe((0, operators_1.materialize)());
            }
        }), (0, operators_1.share)());
        actionResult.pipe((0, operators_1.filter)(function (r) { return r.hasValue && r.kind === 'N'; })).subscribe(function (e) {
            var _a, _b, _c;
            if ((_b = (_a = e.value) === null || _a === void 0 ? void 0 : _a.action) === null || _b === void 0 ? void 0 : _b.onSuccess) {
                if (e.value.action.generateGetUrl) {
                    e.value.action.onSuccess(e.value.url);
                }
                else {
                    e.value.action.onSuccess((_c = e.value) === null || _c === void 0 ? void 0 : _c.response);
                }
            }
        });
        actionResult.pipe((0, operators_1.filter)(function (r) { return r.hasValue === false && r.kind === 'E'; })).subscribe(function (e) {
            var _a, _b;
            if (e.error) {
                var actionWrapper = e.error;
                if ((_a = actionWrapper.action) === null || _a === void 0 ? void 0 : _a.onError) {
                    (_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.onError(actionWrapper.responseError);
                }
            }
        });
        // Custom auth
        var customAuthResult = this.customAuthQueue.pipe((0, operators_1.concatMap)(function (action) {
            var actionWrapper = {
                action: action,
            };
            return (0, rxjs_1.defer)(function () { return _this.getPlain(_this.getBaseUrl(action.action) + '/public/auth', { customToken: action.data }, actionWrapper); }).pipe((0, operators_1.materialize)());
        }), (0, operators_1.share)());
        customAuthResult
            .pipe((0, operators_1.filter)(function (r) { return r.hasValue && r.kind === 'N'; }), (0, operators_1.map)(function (e) {
            var actionWrapper = e.value;
            actionWrapper.tokenData = {
                accessToken: actionWrapper.response.data.accessToken,
                refreshToken: actionWrapper.response.data.refreshToken,
                isServiceToken: false,
                accessTokenExpiresAt: 0,
                refreshTokenExpiresAt: 0,
            };
            if (actionWrapper.response.data.firebase) {
                actionWrapper.tokenData.firebase = {
                    apiKey: actionWrapper.response.data.firebase.apiKey,
                    projectId: actionWrapper.response.data.firebase.projectId,
                    customToken: actionWrapper.response.data.firebase.customToken,
                };
            }
            return actionWrapper;
        }), (0, operators_1.tap)(function (actionWrapper) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!actionWrapper.tokenData) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setTokenData(actionWrapper.tokenData)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.fireAuthStatus(actionWrapper.tokenData);
                        return [2 /*return*/];
                }
            });
        }); }), (0, operators_1.tap)(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.cleanInitFirebase()];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); }))
            .subscribe(function (actionWrapper) { return __awaiter(_this, void 0, void 0, function () {
            var authEvent, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.getAuthChangedEvent;
                        return [4 /*yield*/, this.getStoredTokenData()];
                    case 1:
                        authEvent = _a.apply(this, [_b.sent()]);
                        if (actionWrapper.action.onSuccess) {
                            actionWrapper.action.onSuccess(authEvent);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        customAuthResult.pipe((0, operators_1.filter)(function (r) { return r.hasValue === false && r.kind === 'E'; })).subscribe(function (e) {
            var _a, _b;
            if (e.error) {
                var actionWrapper = e.error;
                if ((_a = actionWrapper.action) === null || _a === void 0 ? void 0 : _a.onError) {
                    (_b = actionWrapper.action) === null || _b === void 0 ? void 0 : _b.onError({
                        authStatus: RBSAuthStatus.AUTH_FAILED,
                        message: actionWrapper.responseError,
                    });
                }
            }
        });
        this.authStatus.subscribe();
        setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.fireAuthStatus;
                        return [4 /*yield*/, this.getStoredTokenData()];
                    case 1:
                        _a.apply(this, [_b.sent()]);
                        return [2 /*return*/];
                }
            });
        }); }, 1);
    };
    RBS.instances = null;
    return RBS;
}());
exports.default = RBS;
//# sourceMappingURL=index.js.map